import React from 'react';
import { Col, Row, Skeleton } from 'antd';
import styled from 'styled-components';

const Root = styled.div`
  width: 100%;
`;

const CardShell = styled.div`
  min-height: 168px;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
`;

const BarStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 8px;
  min-height: 320px;
  justify-content: center;
  width: 100%;
`;

const QuotePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 8px;
  min-height: 320px;
`;

const IllustrationSlot = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
`;

const BAR_WIDTHS_PCT = [88, 72, 64, 58, 70, 52, 80, 46] as const;

const AdminDashboardClassDataSkeletonPage: React.FC = () => (
  <Root>
    <Row
      gutter={[
        { xs: 10, sm: 10, md: 10, lg: 10, xl: 25 },
        { xs: 10, sm: 10, md: 10, lg: 10, xl: 25 },
      ]}
      className="adminVsulRow"
    >
      {Array.from({ length: 7 }).map((_, index) => (
        <Col xs={12} sm={12} md={8} xl={3} key={index} className={index === 0 ? 'studentCountCol' : undefined}>
          <CardShell>
            <Skeleton active title={false} paragraph={{ rows: 2, width: ['80%', '60%'] }} />
            <Skeleton.Avatar active size={index === 0 ? 72 : 96} shape="circle" />
          </CardShell>
        </Col>
      ))}
    </Row>

    <Row className="graphApplyUpr" gutter={[16, 16]} style={{ marginTop: 8 }}>
      <Col xs={{ span: 24 }} lg={{ span: 14 }}>
        <BarStack>
          {BAR_WIDTHS_PCT.map((widthPct, index) => (
            <Skeleton.Input
              key={index}
              active
              style={{ width: `${widthPct}%`, height: 30, borderRadius: 8, minWidth: 0 }}
            />
          ))}
        </BarStack>
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 10 }}>
        <QuotePanel>
          <Skeleton active title={false} paragraph={{ rows: 4, width: ['100%', '95%', '90%', '40%'] }} />
          <Skeleton.Input active size="small" style={{ width: 200, height: 22 }} />
          <IllustrationSlot>
            <Skeleton.Node active style={{ width: 120, height: 100, display: 'block' }} />
          </IllustrationSlot>
        </QuotePanel>
      </Col>
    </Row>
  </Root>
);

export default AdminDashboardClassDataSkeletonPage;
